import script from "./AdminLocationReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLocationReviews.vue?vue&type=script&setup=true&lang=js"

import "./AdminLocationReviews.vue?vue&type=style&index=0&id=45f6153e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f6153e"]])

export default __exports__